/**
 * Authenticated calls to firebase-api (Mongo session store).
 * Use dedicated routes for writes; generic mock Firestore is read-only from pages.
 */
import { auth } from '../firebase';

export function getFirebaseApiUrl() {
  if (process.env.REACT_APP_FIREBASE_API_URL) {
    return process.env.REACT_APP_FIREBASE_API_URL;
  }
  return '/api/firebase';
}

export async function getFirebaseAuthToken() {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

export async function firebaseApiFetch(path, options = {}) {
  const base = getFirebaseApiUrl();
  const p = path.startsWith('/') ? path : `/${path}`;
  const token = options.bearerToken ?? (await getFirebaseAuthToken());

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${base}${p}`, {
    ...options,
    headers,
    body: options.body !== undefined ? JSON.stringify(options.body) : undefined,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || res.statusText || 'Firebase API request failed');
  }

  const text = await res.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    return {};
  }
}
